import cx from 'classnames'
import type React from 'react'
import { useEffect, useRef, useState } from 'react'

import { InputType } from '../Table/TableItem'
import css from './Input.module.scss'

type Props = {
  htmlType?: string
  defaultValue: string | number
  textAlign?: 'left' | 'right'
  width?: number
  name: string
  onChange: (value: string | number) => void
  onFocus?: () => void
  onResetSelectedCall?: () => void
}

export const Input: React.FC<Props> = ({
  htmlType = 'text',
  defaultValue,
  textAlign = 'left',
  width,
  name,
  onChange,
  onFocus,
  onResetSelectedCall,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue)
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    ref.current?.select()
  }, [ref])

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target

    if (name === InputType.VALUE) {
      const v = Number.isNaN(Math.sign(+value)) ? String(defaultValue) : value

      const cutV =
        v.length >= 4 && v.includes('.') ? v.slice(0, 5) : v.slice(0, 3)

      if (cutV !== '') {
        onChange(cutV)
      }

      setInputValue(cutV)
    } else if (name === InputType.NAME) {
      const v = value

      if (v !== '') {
        onChange(v)
      }

      setInputValue(v)
    } else {
      const v =
        Number.isNaN(Math.sign(+value)) || value.includes('.')
          ? defaultValue
          : value

      if (v !== '') {
        onChange(v)
      }

      setInputValue(v)
    }
  }

  const handleOnBlur = () => {
    onResetSelectedCall?.()
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      ref.current?.blur()
    }
  }

  return (
    <input
      ref={ref}
      name={name}
      type={htmlType}
      value={inputValue}
      className={cx(css.input, css[name])}
      style={{ textAlign, width: `width:${width || '100%'}` }}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onKeyDown={handleKeyDown}
      onFocus={onFocus}
    />
  )
}
